const rankingItems = [
  { rank: 1, title: '偶像练习生2026', heat: '9.8', tag: '热播', change: 'up' },
  { rank: 2, title: '极限挑战王第五季', heat: '9.6', tag: '热门', change: 'same' },
  { rank: 3, title: '爱豆音乐舞台纯享', heat: '9.4', tag: '精选', change: 'up' },
  { rank: 4, title: '甜蜜心动观察第三季', heat: '9.2', tag: '新番', change: 'up' },
  { rank: 5, title: '旅行综艺全记录', heat: '9.0', tag: '治愈', change: 'down' },
  { rank: 6, title: '幕后花絮独家揭秘', heat: '8.8', tag: '独家', change: 'up' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-3">
          热播榜单
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          爱豆影视最受欢迎综艺实时排行
        </p>
        <div className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden">
          {rankingItems.map((item, i) => (
            <div
              key={i}
              className={`flex items-center gap-4 px-5 py-4 ${
                i < rankingItems.length - 1 ? 'border-b border-background-200/70' : ''
              } hover:bg-background-100 transition-colors cursor-pointer`}
            >
              <div className="flex-shrink-0 w-8 text-center">
                <span
                  className={`inline-flex items-center justify-center w-7 h-7 rounded-full text-xs font-bold ${
                    item.rank === 1
                      ? 'bg-accent-500 text-background-50 text-sm'
                      : item.rank === 2
                        ? 'bg-primary-400 text-background-50'
                        : item.rank === 3
                          ? 'bg-secondary-400 text-background-50'
                          : 'bg-background-200 text-foreground-500'
                  }`}
                >
                  {item.rank}
                </span>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <h3 className="text-sm font-semibold text-foreground-800 whitespace-nowrap">{item.title}</h3>
                  <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-primary-100 text-primary-700 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="flex-1 h-1.5 rounded-full bg-background-200 overflow-hidden">
                    <div
                      className="h-full rounded-full bg-primary-400"
                      style={{ width: `${(parseFloat(item.heat) / 10) * 100}%` }}
                    ></div>
                  </div>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">热度 {item.heat}</span>
                </div>
              </div>
              <div className="flex-shrink-0">
                {item.change === 'up' && <i className="ri-arrow-up-line text-primary-500 text-sm"></i>}
                {item.change === 'down' && <i className="ri-arrow-down-line text-foreground-400 text-sm"></i>}
                {item.change === 'same' && <i className="ri-subtract-line text-foreground-300 text-sm"></i>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}